import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { corsi } from '../models/corsi';

@Component({
  selector: 'app-hero-courses',
  templateUrl: './hero-courses.component.html',
  styleUrls: ['./hero-courses.component.scss']
})
export class HeroCoursesComponent implements OnInit {
 
  bgColor = "";
  bgImg = "";
  txtColor = "";
  pageTitle = "";
  specialClass = false;

  constructor(public router: Router ) { }

  ngOnInit(): void {
    window.scrollTo(0,0)
    this.bgColor = corsi.find(x=>x.path == this.router.url.split('/')[2])?.bgColor!;
    this.bgImg = corsi.find(x=>x.path == this.router.url.split('/')[2])?.bgImage!;
    this.pageTitle = corsi.find(x=>x.path == this.router.url.split('/')[2])?.title!;
    this.txtColor = corsi.find(x=>x.path == this.router.url.split('/')[2])?.color!;
    this.specialClass = corsi.find(x=>x.path == this.router.url.split('/')[2])?.sc! ? true : false 

   
   
  }

  scrollDown(){
    window.scrollTo(0, 700)

  }

}
